import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { Formik, Form } from 'formik';
import Tippy from '@tippyjs/react';

import useCancellablePromise from 'hooks/useCancellablePromise';
import useModal from 'hooks/useModal';
import { updateUser } from 'reducers/user/actions';
import { SelectField } from 'components/Certifications/CertificationForm/forms/components';
import ConfirmationModal from './ConfirmationModal';


const DeleteDelayForm = ({
  isManager,
  deleteDelay,
  delayOptions,
  editUser,
}) => {
  const [modalOpen, openModal, closeModal] = useModal(false);
  const { cancellablePromise } = useCancellablePromise();


  const onSubmit = (values, actions) => {
    cancellablePromise(editUser(values)).then(() => {
      actions.setSubmitting(false);
      closeModal();
      toast('Delete delay configuration saved!');
    }).catch((err) => {
      if (!err.isCanceled) {
        actions.setSubmitting(false);
        closeModal();
        toast('Something went wrong.');
        throw err;
      }
    });
  };

  return (
    <div>
      <Formik
        initialValues={({ delete_delay_setting: deleteDelay })}
        onSubmit={onSubmit}
        validateOnChange={false}
      >
        {
        ({ isSubmitting }) => (
          <Form
            autoComplete="off"
            noValidate
          >
            <div>
              <Tippy
                content="Only managers are allowed to change the delete delay."
                disabled={isManager}
              >
                <div>
                  <div className="archive-delay-form">
                    <div>
                      <SelectField
                        choices={delayOptions}
                        label="Delete delay"
                        name="delete_delay_setting"
                        disabled={!isManager}
                      />
                    </div>
                  </div>
                  <div className="button-wrapper">
                    <button
                      className="orange-button"
                      type="button"
                      onClick={openModal}
                      disabled={!isManager}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </Tippy>
            </div>
            {

            modalOpen
              ? (
                <ConfirmationModal
                  isSubmitting={isSubmitting}
                  closeModal={closeModal}
                />
              )
              : null
            }
          </Form>
        )
      }
      </Formik>
    </div>
  );
};


const mapStateToProps = ({ user }) => ({
  isManager: user.is_manager,
  deleteDelay: user.delete_delay_setting,
});

DeleteDelayForm.propTypes = {
  isManager: PropTypes.bool.isRequired,
  deleteDelay: PropTypes.number,
  delayOptions: PropTypes.array.isRequired,
  editUser: PropTypes.func.isRequired,
};

DeleteDelayForm.defaultProps = {
  deleteDelay: null,
};

export default connect(mapStateToProps, {
  editUser: updateUser,
})(DeleteDelayForm);
